import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { FormContext } from './FormContext'

/**
 * The Form component is used to collect, validate, and submit the user input.
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-form.html
 *
 * @param {React.ReactNode} [children] - The content to display inside the Form component.
 * @param {string} [className] - Additional CSS classes on the component element.
 * @param {boolean} [floatingLabel] - Enables floating labels.
 * @param {string} [testId] - The `[data-testid]` attribute on the component element.
 * @param {object} [otherProps] - Other props passed to the component element.
 * @return {JSX.Element} - The Form component.
 * @constructor
 */
export function Form({ children, className, floatingLabel, testId, ...otherProps }) {
  const contextValue = {
    floatingLabel,
  }

  const classNameList = classNames(
    {
      'js-floating-label': floatingLabel,
      'is-js-on': floatingLabel,
    },
    className
  ).trim()

  return (
    <form className={classNameList} data-testid={testId} {...otherProps}>
      <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>
    </form>
  )
}

Form.propTypes = {
  children: PropTypes.node, // Bronson template: 'content'.
  className: PropTypes.string, // Additional CSS classes on the component element.
  floatingLabels: PropTypes.bool, // Convenience prop for handling floating labels.
  testId: PropTypes.string, // Added for the `[data-testid]` attribute.
}
